import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IDeliveryMessage } from "../interfaces/IDeliveryMessage";
import { IDepositListFilter } from "../interfaces/IDepositListFilter";
import { TokenHttp } from "../services/tokenhttp.service";
import { BaseRepository } from "./base.repository";

@Injectable()
export class DeliveryMessageRepository extends BaseRepository {
  constructor(tokenHttp: TokenHttp) { 
    super(tokenHttp);
  }

  public getDeliveryMessages(filter: IDepositListFilter): Observable<IDeliveryMessage[]> {
    return this.mapGet("deliveryMessage/getall", filter);
  }

  public getDeliveryMessagesForCarrier(filter: IDepositListFilter): Observable<IDeliveryMessage[]> {
    return this.mapGet("deliveryMessage/getallForCarrier", filter);
  }

  public getDeliveryMessage(id: number): Observable<IDeliveryMessage> {
    return this.mapGet("deliveryMessage/getbyid", {id});
  }

  public addCarrier(deliveryMessageId: number, carrierId: number): Observable<IDeliveryMessage> {
    return this.mapPost("deliveryMessage/addCarrier", { deliveryMessageId, carrierId });
  }

  public removeCarrier(deliveryMessageId: number, carrierId: number): Observable<IDeliveryMessage> {
    return this.mapPost("deliveryMessage/removeCarrier", { deliveryMessageId, carrierId });
  }

  public approve(id: number): Observable<IDeliveryMessage> {
    return this.mapPost(`deliveryMessage/${id}/approve`);
  }

  public changeCommenceDate(value: {deliveryMessageId: number, newDate: Date | string}) {
    return this.mapPut(`deliveryMessage/change-commence-date`, value);
  }

  public getAllDeliveryMessagesForList(): Observable<IDeliveryMessage[]> {
    return this.mapGet("deliveryMessage/getAllForList");
  }
}